import { AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react';
import clsx from 'clsx';

interface AlertProps {
  type: 'error' | 'success' | 'info' | 'warning';
  children: React.ReactNode;
  className?: string;
}

export function Alert({ type, children, className }: AlertProps) {
  const icons = {
    error: AlertCircle,
    success: CheckCircle,
    info: Info,
    warning: AlertTriangle,
  };

  const Icon = icons[type];

  const styles = {
    error: 'bg-error-50 text-error-700 dark:bg-[rgb(var(--error-900)/0.2)] dark:text-error-200',
    success: 'bg-success-50 text-success-700 dark:bg-[rgb(var(--success-900)/0.2)] dark:text-success-200',
    info: 'bg-info-50 text-info-700 dark:bg-[rgb(var(--info-900)/0.2)] dark:text-info-200',
    warning: 'bg-warning-50 text-warning-700 dark:bg-[rgb(var(--warning-900)/0.2)] dark:text-warning-200',
  };

  return (
    <div className={clsx('p-4 rounded-lg flex items-start', styles[type], className)} role="alert">
      <Icon className="h-5 w-5 flex-shrink-0 mr-3 mt-0.5" />
      <div className="text-sm">{children}</div>
    </div>
  );
}